import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Upload, message, Button } from 'antd'
import {
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from '@ant-design/icons'

const baseUrl = process.env.REACT_APP_API_BASE_URL

const UploadImage = ({
  onChange,
  defaultValueImg,
  text = 'Upload',
  styleImagePreview,
}) => {
  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')

  const handleChange = (info) => {
    // console.log(info)
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }

    if (info.file.status === 'done') {
      // console.log(info.file.response)
      // console.log(onChange)
      const imageUrl = info.file.response.storageUrl
      setImageUrl(`${imageUrl}`)
      setLoading(false)
      onChange(info.file.response.storageUrl)
      return imageUrl
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">{text}</div>
    </div>
  )

  let url
  if (defaultValueImg) {
    url = defaultValueImg
  }
  if (imageUrl) {
    url = imageUrl
  }

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }

    return isJpgOrPng && isLt2M
  }

  return (
    <Upload
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      action={`${baseUrl}/container/upload`}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      accept=".jpg,.png,.jpeg"
      headers={{
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }}

      // {...rest}
    >
      {url ? (
        <img
          src={url}
          alt="avatar"
          style={{ width: '95%', cursor: 'pointer', ...styleImagePreview }}
        />
      ) : (
        uploadButton
      )}
      {url === 0 ? <Button icon={<UploadOutlined />}>{text}</Button> : null}
      {url === 0 ? uploadButton : null}
    </Upload>
  )
}

// UploadComponent.propTypes = {
//   imageUrl: PropTypes.string,
//   defaultValueImg: PropTypes.object,
//   uploadButton: PropTypes.node,
//   handleChange: PropTypes.func,
// }

UploadImage.propTypes = {
  defaultValueImg: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
  text: PropTypes.string,
  onChange: PropTypes.func,
  styleImagePreview: PropTypes.object,
}

export default UploadImage
